module.exports = __webpack_public_path__ + "img/sailitics.5f2b4189.png";